// Helpers shared by the rich-text editor and renderer.

export const isHtml = (s) => /<\/?[a-z][\s\S]*>/i.test(s || "");
export const isVideoFile = (u) => /\.(mp4|webm|mov|ogg)(\?|$)/i.test(u || "");
export const isAudioFile = (u) => /\.(mp3|wav|m4a|aac|ogg)(\?|$)/i.test(u || "");

// Convert a share URL into an embeddable player URL where possible.
export function toEmbed(url) {
  try {
    const u = new URL(url);
    const h = u.hostname.replace("www.", "");
    if (h === "youtube.com" || h === "m.youtube.com") { const id = u.searchParams.get("v"); if (id) return `https://www.youtube.com/embed/${id}`; }
    if (h === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    if (h === "vimeo.com") return `https://player.vimeo.com/video/${u.pathname.split("/").filter(Boolean)[0]}`;
    if (h === "open.spotify.com") return `https://open.spotify.com/embed${u.pathname}`;
    if (h.endsWith("apple.com") && u.pathname.includes("/podcast")) return url.replace("podcasts.apple.com", "embed.podcasts.apple.com");
  } catch { /* ignore */ }
  return url;
}

const esc = (s) => (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// Convert the AI's plain-text draft (blank-line paragraphs, "## " headings, "- " lists) into HTML
// so it can be edited in the rich-text editor.
export function plainToHtml(text) {
  if (!text) return "";
  if (isHtml(text)) return text;
  const blocks = text.split(/\n{2,}/);
  const out = [];
  for (const block of blocks) {
    const lines = block.split("\n").filter((l) => l.trim());
    if (!lines.length) continue;
    if (lines.every((l) => l.trim().startsWith("- "))) {
      out.push("<ul>" + lines.map((l) => `<li>${esc(l.trim().slice(2))}</li>`).join("") + "</ul>");
    } else if (lines[0].startsWith("## ")) {
      out.push(`<h2>${esc(lines[0].slice(3))}</h2>`);
      const rest = lines.slice(1).join(" ");
      if (rest) out.push(`<p>${esc(rest)}</p>`);
    } else if (lines[0].startsWith("### ")) {
      out.push(`<h3>${esc(lines[0].slice(4))}</h3>`);
      const rest = lines.slice(1).join(" ");
      if (rest) out.push(`<p>${esc(rest)}</p>`);
    } else {
      out.push(`<p>${esc(lines.join(" "))}</p>`);
    }
  }
  return out.join("\n");
}
